var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightbulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6117_121677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 1.5V2.25M2.25 9H1.5M4.125 4.125L3.67493 3.67493M13.875 4.125L14.3252 3.67493M16.5 9H15.75M7.5 10.125H10.5M9 10.125V13.875M11.625 12.6555C12.7606 11.8386 13.5 10.5056 13.5 9C13.5 6.51472 11.4853 4.5 9 4.5C6.51472 4.5 4.5 6.51472 4.5 9C4.5 10.5056 5.23945 11.8386 6.375 12.6555V14.1C6.375 14.9401 6.375 15.3601 6.53849 15.681C6.6823 15.9632 6.91177 16.1927 7.19401 16.3365C7.51488 16.5 7.93492 16.5 8.775 16.5H9.225C10.0651 16.5 10.4851 16.5 10.806 16.3365C11.0882 16.1927 11.3177 15.9632 11.4615 15.681C11.625 15.3601 11.625 14.9401 11.625 14.1V12.6555Z",
    stroke: "#0E0E0E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 1.5V2.25M2.25 9H1.5M4.125 4.125L3.67493 3.67493M13.875 4.125L14.3252 3.67493M16.5 9H15.75M7.5 10.125H10.5M9 10.125V13.875M11.625 12.6555C12.7606 11.8386 13.5 10.5056 13.5 9C13.5 6.51472 11.4853 4.5 9 4.5C6.51472 4.5 4.5 6.51472 4.5 9C4.5 10.5056 5.23945 11.8386 6.375 12.6555V14.1C6.375 14.9401 6.375 15.3601 6.53849 15.681C6.6823 15.9632 6.91177 16.1927 7.19401 16.3365C7.51488 16.5 7.93492 16.5 8.775 16.5H9.225C10.0651 16.5 10.4851 16.5 10.806 16.3365C11.0882 16.1927 11.3177 15.9632 11.4615 15.681C11.625 15.3601 11.625 14.9401 11.625 14.1V12.6555Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 1.5V2.25M2.25 9H1.5M4.125 4.125L3.67493 3.67493M13.875 4.125L14.3252 3.67493M16.5 9H15.75M7.5 10.125H10.5M9 10.125V13.875M11.625 12.6555C12.7606 11.8386 13.5 10.5056 13.5 9C13.5 6.51472 11.4853 4.5 9 4.5C6.51472 4.5 4.5 6.51472 4.5 9C4.5 10.5056 5.23945 11.8386 6.375 12.6555V14.1C6.375 14.9401 6.375 15.3601 6.53849 15.681C6.6823 15.9632 6.91177 16.1927 7.19401 16.3365C7.51488 16.5 7.93492 16.5 8.775 16.5H9.225C10.0651 16.5 10.4851 16.5 10.806 16.3365C11.0882 16.1927 11.3177 15.9632 11.4615 15.681C11.625 15.3601 11.625 14.9401 11.625 14.1V12.6555Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6117_121677"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/lightbulb.88617b5287f944229b07da4530e7c559.svg";
export { ForwardRef as ReactComponent };